import React from 'react';

import { EMAIL_VERIFICATION_STATE, useEmailVerification, useLabel } from '@atlas/core';
import { Icon, TranslateWithLinks } from '@atlas/ui';

import { useEmailVerificationBannerVisibility } from 'src/hooks/useEmailVerificationBannerVisibility';

const EmailVerificationBanner = () => {
  const isVisible = useEmailVerificationBannerVisibility();
  const { email, resend, timeDisplay, verificationState } = useEmailVerification();

  const defaultMessage = useLabel('email_verification_banner_default');
  const cooldownMessage = useLabel('email_verification_banner_cooldown', { time: timeDisplay });
  const cooldownEmailSentMessage = useLabel('email_verification_banner_cooldown_email_sent', {
    email,
  });
  const limitReachedMessage = useLabel('email_verification_banner_limit_reached');
  const limitReachedEmailSentMessage = useLabel(
    'email_verification_banner_limit_reached_email_sent',
    { email },
  );

  if (!isVisible || verificationState === EMAIL_VERIFICATION_STATE.HIDDEN) {
    return null;
  }

  const isDefault =
    verificationState === EMAIL_VERIFICATION_STATE.VERIFY_EMAIL ||
    verificationState === EMAIL_VERIFICATION_STATE.DEFAULT;

  return (
    <div className="email-verification-banner">
      <Icon className="email-verification-banner__icon" name="email-problem" />

      {isDefault && (
        <span className="email-verification-banner__text">
          <TranslateWithLinks actions={resend} translate={defaultMessage} />
        </span>
      )}

      {verificationState === EMAIL_VERIFICATION_STATE.COOLDOWN && (
        <span className="email-verification-banner__text-group">
          <span className="email-verification-banner__text">
            <TranslateWithLinks translate={cooldownMessage} />
          </span>
          <span className="email-verification-banner__subtext">
            <TranslateWithLinks translate={cooldownEmailSentMessage} />
          </span>
        </span>
      )}

      {verificationState === EMAIL_VERIFICATION_STATE.LIMIT_REACHED && (
        <span className="email-verification-banner__text-group">
          <span className="email-verification-banner__text">
            <TranslateWithLinks translate={limitReachedMessage} />
          </span>
          <span className="email-verification-banner__subtext">
            <TranslateWithLinks translate={limitReachedEmailSentMessage} />
          </span>
        </span>
      )}
    </div>
  );
};

export default EmailVerificationBanner;
